import { DisciplineEvaluationAndDeadlines } from '@/models/evaluation-and-deadlines/evaluation-and-deadlines.model';
import { ActiveStudyWindow } from '@/services/undergrad/pegasus-pepe-legal/user-grades.service';
import { MutationTree } from 'vuex';
import { AssessmentState } from './state';

const mutations: MutationTree<AssessmentState> = {
  SET_ACTIVE_STUDY_WINDOWS(state, activeStudyWindows: ActiveStudyWindow[]) {
    state.activeStudyWindows = activeStudyWindows;
  },
  SET_EVALUATION_AND_DEADLINES(state, evaluationAndDeadlines: DisciplineEvaluationAndDeadlines[]) {
    if (!state.evaluationAndDeadlines) {
      state.evaluationAndDeadlines = evaluationAndDeadlines;
      return;
    }

    state.evaluationAndDeadlines.push(...evaluationAndDeadlines);
  },
};

export default mutations;
